import React from 'react';

import { styled } from '@mui/system';

import { Button } from '@mui/material';
import { appInsights } from '../../../auth/appInsight';
import { getStringProduct } from '../../../utils/utilityFunctions';

const FreedomButton = styled(Button)(({ backgroundcolor, buttoncolor, btnborderradius, buttonborder, padding, theme, smpadding, fontweight }) => ({
  background: backgroundcolor,
  color: buttoncolor,
  fontFamily: 'Poppins !important',
  fontWeight: fontweight || '600',
  fontSize: '15.8557px',
  lineHeight: '19px',
  padding: padding || '15px 30px',
  textTransform: 'capitalize',
  borderRadius: btnborderradius,
  border: buttonborder,
  '&:hover': {
    background: backgroundcolor
  },
  [theme.breakpoints.down('sm')]: {
    padding: smpadding || ''
  },
  [theme.breakpoints.up('xll')]: {
    fontSize: getStringProduct(1.25, '15.8557px'),
    lineHeight: getStringProduct(1.25, '19px'),
    padding: getStringProduct(1.25, padding || '15px 30px'),
    borderRadius: getStringProduct(1.25, btnborderradius || '10px'),
    border: getStringProduct(1.25, buttonborder),
  },
  [theme.breakpoints.up('xlll')]: {
    fontSize: getStringProduct(1.66, '15.8557px'),
    lineHeight: getStringProduct(1.66, '19px'),
    padding: getStringProduct(1.66, padding || '15px 30px'),
    borderRadius: getStringProduct(1.66, btnborderradius || '10px'),
    border: getStringProduct(1.66, buttonborder),
  },
  [theme.breakpoints.up('xl4')]: {
    fontSize: getStringProduct(2.46, '15.8557px'),
    lineHeight: getStringProduct(2.46, '19px'),
    padding: getStringProduct(2.46, padding || '15px 30px'),
    borderRadius: getStringProduct(2.46, btnborderradius || '10px'),
    border: getStringProduct(2.46, buttonborder),
  },

}));

const FreedomOutlineButton = (props) => {
  const { starticon, endicon, children } = props;

  try {
    return (
      <FreedomButton {...props} startIcon={starticon} endIcon={endicon}>
        {children}
      </FreedomButton>
    );
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};

export default FreedomOutlineButton;
